<template>
  <div class="coupon-form-container">
    <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%;float: left;">
      <div slot="header" class="form-header">
        <span class="title">创建优惠券</span>
        <span class="subtitle">请填写优惠券详细信息</span>
      </div>

      <el-form :model="form" class="coupon-form" :rules="rules" ref="couponForm" label-width="140px"
        label-position="right" size="medium">
        <!-- 基础信息 -->
        <el-divider content-position="left">基础信息</el-divider>

        <el-form-item label="券类型名称" prop="coupon_name" required>
          <el-input v-model="form.coupon_name" placeholder="请输入优惠券名称" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="领券通道" prop="distribution_channel_no">
          <el-select v-model="form.distribution_channel_no" placeholder="请输入发券方式/通道编号">
            <el-option v-for="item in channel_options" :key="item.channel_no" :label="item.channel_name"
              :value="item.channel_no" :disabled="unSelectChannel.indexOf(item.channel_no) >= 0"></el-option>
          </el-select>
          <div class="form-tip">例如: APP, WECHAT, OFFLINE 等</div>
        </el-form-item>
        <!-- <el-form-item label="适用门店" prop="branch_scope">
          <el-select v-model="form.branch_scope" multiple placeholder="请选择适用门店，默认9999代表全部门店">
            <el-option label="全部门店 (9999)" value="9999"></el-option>
          </el-select>
          <div class="form-tip">注：默认"9999"代表全部门店，您也可以选择其他具体门店</div>
        </el-form-item> -->

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始有效期" prop="start_time" required>
              <el-date-picker v-model="form.start_time" type="datetime" placeholder="选择开始时间"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="new Date(2000, 0, 1, 0, 0, 0)" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束有效期" prop="expire_time" required>
              <el-date-picker v-model="form.expire_time" type="datetime" placeholder="选择结束时间"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="new Date(2000, 0, 1, 23, 59, 59)" style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 优惠内容 -->
        <el-divider content-position="left">优惠内容</el-divider>

        <!-- <el-form-item label="优惠类型" prop="coupon_type">
          <el-radio-group v-model="couponType" @change="handleCouponTypeChange">
            <el-radio label="amount">满减券 (固定金额)</el-radio>
            <el-radio label="discount">折扣券 (按比例)</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item v-if="couponType === 'amount'" label="券优惠金额" prop="amount" required>
          <el-input v-model="form.amount" :precision="2" :min="0" :max="999999" placeholder="请输入金额" style="width: 100%">
          </el-input>
          <span class="unit">元</span>
        </el-form-item>

        <el-form-item v-if="couponType === 'discount'" label="券折扣率" prop="discount" required>
          <el-input v-model="form.discount" :precision="2" :min="0" :max="10" :step="0.1" placeholder="请输入折扣率"
            style="width: 100%">
          </el-input>
          <span class="unit">折 (例如8.5折请输入8.5)</span>
        </el-form-item>

        <el-form-item label="满足金额门槛" prop="amount_require">
          <el-input v-model="form.amount_require" :precision="2" :min="0" placeholder="0表示无门槛" style="width: 100%">
          </el-input>
          <span class="unit">元</span>
        </el-form-item>

        <el-form-item label="满足数量门槛" prop="qty_require">
          <el-input v-model="form.qty_require" :min="0" :step="1" placeholder="0表示无数量限制" style="width: 100%">
          </el-input>
          <span class="unit">件</span>
        </el-form-item>

        <el-form-item v-if="coupon_base.key === 'custom'" label="金额与数量关系" prop="both_require">
          <el-radio-group v-model="form.both_require">
            <el-radio :label="false">满足任一条件即可</el-radio>
            <el-radio :label="true">需同时满足金额和数量</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="coupon_base.key === 'custom'" label="优惠计算方式" prop="is_stackable">
          <el-radio-group v-model="form.is_stackable">
            <el-radio :label="false">互斥 (折扣和金额二选一)</el-radio>
            <el-radio :label="true">折上折 (先折扣再减金额)</el-radio>
          </el-radio-group>
          <div class="form-tip">当同时存在折扣和金额优惠时，此设置决定计算顺序</div>
        </el-form-item>

        <!-- 使用限制 -->
        <!-- <el-divider content-position="left">使用限制</el-divider>

        <el-form-item label="适用商品范围" prop="goods_scope">
          <el-select v-model="form.goods_scope" multiple filterable allow-create placeholder="请输入商品ID或SKU，留空表示全部商品">
            <el-option label="全部商品 (空数组)" :value="null" disabled></el-option>
          </el-select>
          <div class="form-tip">支持手动输入商品ID，留空表示全部商品适用</div>
        </el-form-item>

        <el-form-item label="适用分类范围" prop="classify_scope">
          <el-select v-model="form.classify_scope" multiple filterable allow-create placeholder="请输入分类ID，留空表示全部分类">
          </el-select>
          <div class="form-tip">支持手动输入分类ID</div>
        </el-form-item> -->

        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="限定日期范围" prop="date_scope">
              <el-date-picker v-model="form.date_scope" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="datePickerOptions"
                style="width: 100%">
              </el-date-picker>
              <div class="form-tip">不选则不限制日期</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="限定时间范围" prop="time_scope">
              <el-time-picker v-model="form.time_scope" is-range range-separator="至" start-placeholder="开始时间"
                end-placeholder="结束时间" placeholder="选择时间段" value-format="HH:mm" style="width: 100%">
              </el-time-picker>
              <div class="form-tip">不选则不限制时间</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="每周可用日" prop="week_scope" style="margin-top: 40px;">
          <el-checkbox-group v-model="weekScopeValue">
            <el-checkbox :label="1">周一</el-checkbox>
            <el-checkbox :label="2">周二</el-checkbox>
            <el-checkbox :label="3">周三</el-checkbox>
            <el-checkbox :label="4">周四</el-checkbox>
            <el-checkbox :label="5">周五</el-checkbox>
            <el-checkbox :label="6">周六</el-checkbox>
            <el-checkbox :label="7">周日</el-checkbox>
          </el-checkbox-group>
          <div class="form-tip">未选中任何星期表示不限制</div>
        </el-form-item>
-->
        <!-- 发放与库存 -->
        <el-divider content-position="left">发放与库存</el-divider>

        <el-form-item label="总发行数量" prop="total_quantity">
          <el-input v-model="form.total_quantity" :min="0" :step="1" placeholder="不填或0表示不限制"
            style="width: 100%"></el-input>
          <span class="unit">张 (0或空表示不限量)</span>
        </el-form-item>

        <el-form-item label="单次最大使用数量" prop="max_use_quantity">
          <el-input v-model="form.max_use_quantity" :min="1" :step="1" style="width: 100%"></el-input>
          <span class="unit">张/单据</span>
        </el-form-item>

        <el-form-item label="每人最大领取数量" prop="max_claim_quantity">
          <el-input v-model="form.max_claim_quantity" :min="0" :max="10" :step="1" style="width: 100%"></el-input>
          <span class="unit">张 (0表示不限制)</span>
        </el-form-item>

        <el-form-item label="每日领取限制" prop="day_claim_quantity">
          <el-input v-model="form.day_claim_quantity" :min="0" :step="1" placeholder="不填或0表示不限制"
            style="width: 100%"></el-input>
          <span class="unit">张/天（该卷每天总共可领取数量）</span>
        </el-form-item>
        <el-form-item v-if="coupon_base.key === 'custom' || coupon_base.key === 'fenxiang'" label="能否被分享"
          prop="has_share">
          <el-radio-group v-model="form.has_share">
            <el-radio :label="true">允许分享</el-radio>
            <el-radio :label="false">不允许分享</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注信息" prop="remark">
          <el-input type="textarea" v-model="form.remark" rows="3" placeholder="请输入备注信息" maxlength="200"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item>

        </el-form-item>
      </el-form>
    </el-scrollbar>
    <!-- 提交按钮 -->
    <div class="bottom-btn">
      <el-button type="primary" v-if="key === 'create'" @click="submitForm" :loading="submitting">立即创建</el-button>
      <el-button type="primary" v-else @click="submitForm" :loading="submitting">保存修改</el-button>
      <!-- <el-button @click="resetForm">还原修改</el-button> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getGeneralCouponInfo, formatMoney, formatCoupon } from '../js/couponInfo.js';
import { getListDistributionChannels, couponCreate, couponUpdate } from "@/api/coupon/coupon.js";

export default {
  data() {
    return {
      couponType: 'amount', // 'amount' 或 'discount'
      coupon_base: {}, //基本的卷数据
      channel_options: [], //所有领卷通道
      unSelectChannel: ["02", "03", "04", "06"],
      form: {
        coupon_name: '',
        branch_scope: ['9999'], // 默认全部门店
        start_time: "",
        expire_time: "",
        amount: 0,
        discount: 1, // 折扣率，默认1即无折扣
        amount_require: 0,
        is_stackable: false,
        qty_require: 0,
        both_require: false,
        date_scope: [], // 空表示不限制
        time_scope: [], // 空表示不限制
        week_scope: "1111111", // 后端期望长度为7的数组，前端用checkbox存储选中的星期值
        goods_scope: [], // 空数组表示全部商品
        classify_scope: [], // 空数组表示全部分类
        remark: '',
        has_share: true, // 默认可分享
        total_quantity: 0, // null或0表示不限制
        max_use_quantity: 1,
        max_claim_quantity: 1,
        day_claim_quantity: [],
        distribution_channel_no: ''
      },
      weekScopeValue: "1111111", // 辅助存储选中的星期数字
      submitting: false,
      datePickerOptions: {
        disabledDate(time) {
          // 可选：禁止选择今天之前的日期
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      rules: {
        coupon_name: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        start_time: [
          { required: true, message: '请选择开始有效期', trigger: 'change' }
        ],
        distribution_channel_no: [
          { required: true, message: '请选择领卷通道', trigger: 'change' }
        ],
        expire_time: [
          { required: true, message: '请选择结束有效期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.form.start_time && value && new Date(value) <= new Date(this.form.start_time)) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        amount: [
          {
            validator: (rule, value, callback) => {
              if (this.couponType === 'amount' && (value === undefined || value === null || value <= 0)) {
                callback(new Error('满减券金额必须大于0'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        discount: [
          {
            validator: (rule, value, callback) => {
              if (this.couponType === 'discount' && (value === undefined || value === null || value <= 0 || value > 10)) {
                callback(new Error('折扣率必须在0到10之间'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        amount_require: [
          {
            validator: (rule, value, callback) => {
              if (value < 0) callback(new Error('满足金额不能为负数'));
              else callback();
            },
            trigger: 'blur'
          }
        ],
        qty_require: [
          {
            validator: (rule, value, callback) => {
              if (value < 0) callback(new Error('满足数量不能为负数'));
              else callback();
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    // 监听星期选择变化，转换为后端需要的长度为7的数组
    /* weekScopeValue: {
      handler(newVal) {
        const weekArr = [0, 0, 0, 0, 0, 0, 0];
        newVal.forEach(day => {
          if (day >= 1 && day <= 7) {
            weekArr[day - 1] = 1;
          }
        });
        this.form.week_scope = weekArr;
      },
      immediate: true,
      deep: true
    }, */
    // 如果优惠类型变化，重置对应字段的值（避免冲突）
    couponType(newType) {
      if (newType === 'amount') {
        this.form.discount = 1;
      } else {
        this.form.amount = 0;
      }
    }
  },
  created() {
    if (this.$route.params.key) {
      this.key = this.$route.params.key;
    }

    if (this.$route.params.value) {
      this.coupon_base = JSON.parse(this.$route.params.value);
      if (this.key === "create") {
        this.form = getGeneralCouponInfo(this.coupon_base);
        /* if (this.coupon_base.key === "fenxiang") {
          this.form.distribution_channel_no = "05";
        } */
      } else if (this.key == "update") {
        this.form = formatCoupon(JSON.parse(JSON.stringify(this.coupon_base)));
      }
    }
    this.getChannerl();
  },
  methods: {
    /**
     * 获取所有领卷通道
     */
    async getChannerl() {
      this.channel_options = await getListDistributionChannels();
    },
    handleCouponTypeChange(val) {
      // 额外处理：可清空校验
      this.$nextTick(() => {
        this.$refs.couponForm.clearValidate(['amount', 'discount']);
      });
    },
    // 提交表单
    submitForm() {
      this.submitting = true;
      console.log("this.form====================", this.form);
      this.$refs.couponForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请填写完整且正确的信息');
          this.submitting = false;
          return false;
        }

        // 准备提交的数据，进行深度拷贝并根据业务规则调整
        const submitData = formatMoney(JSON.parse(JSON.stringify(this.form)), "upload");
        // 若有branch_scope包含9999，可简化，但保留原值
        console.log('提交的优惠券数据:', submitData);
        if (this.key === 'create') {
          const res = await couponCreate(submitData);
          if (res.state === true) {
            this.successMessage(res.message);
          }
        } else if (this.key === 'update') {
          const updateRes = await couponUpdate(submitData);
          if (updateRes.state === true) {
            this.successMessage(updateRes.message);
          }
          console.log("0------------------------------", updateRes);
        }

        this.submitting = false;

        // 模拟API请求

        // 实际项目中调用接口：
        // this.$http.post('/api/coupon/create', submitData).then(res => {...}).catch(err => {...}).finally(() => this.submitting = false);
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.$refs.couponForm.resetFields();
      // 手动重置一些初始值，因为resetFields可能不会重置复杂字段
      this.couponType = 'amount';
      this.form = getGeneralCouponInfo(this.coupon_base);
      this.weekScopeValue = "1111111";
      this.$nextTick(() => {
        this.$refs.couponForm.clearValidate();
      });
      this.$message.info('已重置卡卷');
    }
  },
  mounted() {
    /* // 初始化星期数组：从已有的 week_scope 构建选中值（如果有预设）
    if (this.form.week_scope && this.form.week_scope.length === 7) {
      const selected = [];
      this.form.week_scope.forEach((val, idx) => {
        if (val === 1) selected.push(idx + 1);
      });
      this.weekScopeValue = selected;
    } */
  }
};
</script>

<style scoped>
.coupon-form {
  background-color: #fff;
  width: 90%;
}

.el-input {
  width: 400px !important;
}

.el-select {
  width: 400px !important;

}

.bottom-btn {
  height: 50px;
  padding-top: 10px;
}

.coupon-form-container {
  padding: 20px;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #fff;
  margin: 0px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.form-card {
  max-width: 1000px;
  margin: 0 auto;
}

.form-header {
  display: flex;
  align-items: baseline;

}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-right: 12px;
}

.subtitle {
  font-size: 12px;
  color: #909399;
}

.unit {
  margin-left: 8px;
  color: #606266;
  font-size: 12px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}

::v-deep .el-divider__text {
  font-weight: 500;
  color: #409EFF;
}

::v-deep .el-form-item {
  margin-bottom: 22px;
}

::v-deep .el-select,
::v-deep .el-input {
  width: 100%;
}
</style>